import { useTranslation } from 'react-i18next';

import { AnchorTargets } from '~/constants/url';

import { SettingsSection, SettingsSections } from '../components/SettingsSection';
import { EmailSettings } from './EmailSettings/EmailSettings';

export const Email = () => {
  const { t } = useTranslation(['settings']);

  return (
    <SettingsSections>
      <SettingsSection id={AnchorTargets.SETTINGS_EMAIL_SETTINGS} title={t('settings:general.email.title')}>
        <EmailSettings />
      </SettingsSection>
    </SettingsSections>
  );
};
